export const apiBaseUrl = window.location.protocol === 'https:' ? 'https://opsmoutcome.torcai.com' : 'https://opsmoutcome.torcai.com';
export const creativeGenerationApiBaseUrl = apiBaseUrl;
export const phpApiBaseUrl = window.location.protocol === 'https:' ? 'https://stagemvp.torcai.com/beki/' : 'https://stagemvp.torcai.com/beki/';
export const apiFileUploadBaseUrl = 'https://opsmoutcome.torcai.com/atd';
export const authBaseUrl = 'https://opsmoutcome.torcai.com';
export const timestampBaseUrl = 'https://opsmoutcome.torcai.com/atd';
//export const apiDruidBaseUrl = "https://oneaudiencedcr.torcai.com:9441";
export const demoTenantBaseUrl = "https://atdtestdemo.torcai.com";
export const apiDruidBaseUrl = apiBaseUrl;
export const version = '1.0.0';
export const domain = 'torcai.in';
export const constants = {};
export const tenantIdsToShowDemoData = [535, 536];

// export const soundTrackBaseUrl = window.location.protocol === 'https:' ? 'https://stagepublisherV2.torcai.com' : 'http://stagepublisherV2.torcai.com';
export const soundTrackBaseUrl = window.location.protocol === 'https:' ? 'https://opsmoutcome.torcai.com' : 'https://opsmoutcome.torcai.com';

export const endPoints = {
  atd: '/report-atd',
  // atdDashboard : '/report-atd/dashboard',
  tai: '/tai/solr',
  atdDashboard: '/druid/dashboard',
  auth: '/auth/v3',
  geo: '/tai/geo/torcai',
  bidder: '/bidder/report',
  io: '/io',
  campaign: '/campaign',
  audience: '/audience',
  campaignPmp: '/campaign-pmp',
  creative: '/creative',
  medialist: '/medialist',
  data: '/data',
  ionReport: '/ion/report',
  adUnitBulk: '/adunitbulk',
  adUnitMap: '/adunitmap',
  mediation: '/mediation',
  pmp: '/pmp',
  adgroup: '/adgroup',
  adunit: '/adunit',
  payment: "/payment",
  fb: '/fb',
  subscription: '/subscription',
  tiktok: '/tiktok',
  dataConfig: '/dataconfig',
  variable: '/variable',
  beki: 'beki'
}
export const cdnUrl = window.location.protocol === 'https:' ? 'https://stagecdn.torcai.com' : 'https://stagecdn.torcai.com';

export const platformConfigUrl = 'https://stagecdn.torcai.com/platforms.json';
export const defaultPlatformConfig = {
  "id": 7,
  "name": "Beki",
  "domain": "https://beki.torcai.com",
  "cDate": "2024-04-17 18:45:06",
  "mDate": "2024-04-17 18:47:17",
  "cUser": 334,
  "mUser": 0,
  "isSelfServe": false,
  "isActive": 1,
  "template": 1,
  "lable": {
    "id": 7,
    "logo": [
      {
        "name": "Beki",
        "path": "https://cdn.torcai.com/images/bekiLogo.png",
        "img": {
          "width": "464",
          "height": "200"
        }
      }
    ],
    "pColor": "#506ee4",
    "sColor": "#edf0f5",
    "oColor": "#9ba7ca00",
    "fontFamily": [
      {
        "fontName": "poppins",
        "fontPath": "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap",
        "size": 0
      }
    ],
    "fontSize": 14,
    "fontColor": "#656d9a",
    "favicon": "https://stagecdn.torcai.com/logos/1716449056666favicon.png",
    "base": "0",
    "currency": [
      "70",
      "71",
      "1363",
      "1366",
      "1367",
      "1368",
      "1647",
      "1648",
      "1649",
      "1650",
      "1651",
      "1652",
      "1653",
      "1654",
      "1655",
      "1656",
      "1657",
      "1658",
      "1659",
      "1660",
      "1661",
      "1662",
      "1663",
      "1664",
      "1665",
      "1666",
      "1667",
      "1668",
      "1669",
      "1670",
      "1671",
      "1672",
      "1673",
      "1674",
      "1675",
      "1676",
      "1677",
      "1678",
      "1679",
      "1680",
      "1681",
      "1682",
      "1683",
      "1684",
      "1685",
      "1686",
      "1687",
      "1688",
      "1689",
      "1690",
      "1691",
      "1692",
      "1693",
      "1694",
      "1695",
      "1696",
      "1697",
      "1698",
      "1699",
      "1700",
      "1701",
      "1702",
      "1703",
      "1704",
      "1705",
      "1706",
      "1707",
      "1708",
      "1709",
      "1710",
      "1711",
      "1712",
      "1713",
      "1714",
      "1715",
      "1716",
      "1717",
      "1718",
      "1719",
      "1720",
      "1721",
      "1722",
      "1723",
      "1724",
      "1725",
      "1726",
      "1727",
      "1728",
      "1729",
      "1730",
      "1731",
      "1732",
      "1733",
      "1734",
      "1735",
      "1736",
      "1737",
      "1738",
      "1739",
      "1740",
      "1741",
      "1742",
      "1743",
      "1744",
      "1745",
      "1746",
      "1747",
      "1748",
      "1749",
      "1750",
      "1751",
      "1752",
      "1753",
      "1754",
      "1755",
      "1756",
      "1757",
      "1758",
      "1759",
      "1760",
      "1761",
      "1762",
      "1763",
      "1764",
      "1765",
      "1766",
      "1767",
      "1768",
      "1769",
      "1770",
      "1771",
      "1772",
      "1773",
      "1774",
      "1775",
      "1776",
      "1777",
      "1778",
      "1779",
      "1780",
      "1781",
      "1782",
      "1783",
      "1784",
      "1785",
      "1786",
      "1787",
      "1788",
      "1789",
      "1790",
      "1791",
      "1792",
      "1793",
      "1794",
      "1795",
      "1796",
      "1797",
      "1798",
      "1799",
      "1800",
      "1801"
    ]
  }
};

export const CONTEXT = '/atd';
// export const torcaiTracking = apiBaseUrl + '/audtrack/postback/track?'
export const torcaiTracking = soundTrackBaseUrl + '/audtrack/postback/track?'
// export const tomcatApiUrl = apiBaseUrl.replace(window.location.protocol, "") + '/content/dmp';
export const tomcatApiUrl = cdnUrl.replace(window.location.protocol, "") + '/dmp/ifrm';
// export const iFrameApiUrl = apiBaseUrl + '/dmp/jsv2';
export const iFrameApiUrl = cdnUrl + '/dmp/ifrm';
// export const imageApiUrl = apiBaseUrl + '/audtrack/param/track?';
export const imageApiUrl = soundTrackBaseUrl + '/audtrack/param/track?';